/**
 *
 * Asynchronously loads the component for AnnualStats
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
